export enum TableColumnType {
    checkBoxSelectAll = 'checkBox-select-all',
    checkBox = 'checkBox',
    button = 'button',
    label = 'label',
    labelAndToolTip = 'labelAndToolTip',
    input = 'input',
    hyperLink = 'hyperLink',
    buttonToggle = 'buttonToggle',
    iconButton = 'iconButton',
    slideToggle = 'slideToggle',
    dropDown = 'dropDown',
}